(function () {
  function escapeId(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return value.replace(/([ !\"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, '\\$1');
  }

  function bindTocScroll(sectionContainer) {
    if (!sectionContainer || sectionContainer.dataset.pcLegalTocBound === 'true') return;

    var sectionRoot = sectionContainer.querySelector('.pc-legal-shell');
    if (!sectionRoot) return;

    var policySection = sectionContainer.querySelector('.pc-legal-page');
    var extraOffset = policySection ? Number(policySection.dataset.anchorOffset || 0) : 0;

    var tocLinks = sectionRoot.querySelectorAll('.pc-legal-toc a[href^="#"]');
    if (!tocLinks.length) return;

    sectionContainer.dataset.pcLegalTocBound = 'true';

    tocLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var hash = link.getAttribute('href');
        if (!hash || hash === '#') return;

        var targetId = hash.slice(1);
        var target = sectionContainer.querySelector('#' + escapeId(targetId));
        if (!target) return;

        event.preventDefault();

        var headerOffset = getHeaderOffset() + extraOffset;
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        if (targetTop < 0) targetTop = 0;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });

        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', hash);
        }
      });
    });
  }

  function getHeaderOffset() {
    var candidates = [
      'sticky-header',
      '#shopify-section-header',
      '.section-header',
      '.header-wrapper',
      'header.header'
    ];

    var maxHeight = 0;
    candidates.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function (element) {
        var rect = element.getBoundingClientRect();
        var height = rect.height || element.offsetHeight || 0;
        if (height > maxHeight) maxHeight = height;
      });
    });

    return maxHeight + 16;
  }

  function initAll() {
    document.querySelectorAll('.section-pc-legal-policy').forEach(bindTocScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindTocScroll(event.target);
  });
})();
